export default {
  NETDB_API_BASE_URL: '/api/',
  NETDB_API_VERSION: '4.1',
  ENABLE_OIC: true,
  BUILD_ID: 'f82277e3,Job ID 1624951@',
  COMMIT_SHORT_SHA: 'f82277e3',
  JOB_ID: '1624951'
}
